import { useEffect, useState } from "react";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { Loader2, Users } from "lucide-react";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-customers">
      <h2 className="font-display text-xl font-bold uppercase tracking-tight mb-6">Customers ({customers.length})</h2>
      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
      ) : customers.length === 0 ? (
        <div className="border border-zinc-800 bg-zinc-950 p-12 text-center">
          <Users className="h-10 w-10 text-zinc-600 mx-auto" />
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-zinc-500">No customers yet</p>
        </div>
      ) : (
        <div className="border border-zinc-800 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-zinc-900 font-mono text-[10px] uppercase tracking-widest text-zinc-500">
              <tr>
                <th className="text-left p-3">Customer</th>
                <th className="text-left p-3 hidden sm:table-cell">Email</th>
                <th className="text-left p-3">Orders</th>
                <th className="text-left p-3">Total Spend</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-900">
              {customers.map((c) => (
                <tr key={c.id} data-testid={`customer-row-${c.id}`} className="hover:bg-zinc-900/50">
                  <td className="p-3 flex items-center gap-2">
                    {c.picture ? <img src={c.picture} alt="" className="h-7 w-7 rounded-full" /> : <div className="h-7 w-7 rounded-full bg-zinc-800 flex items-center justify-center text-[10px] font-bold">{(c.name || c.email)[0]?.toUpperCase()}</div>}
                    <span>{c.name || "—"}</span>
                  </td>
                  <td className="p-3 hidden sm:table-cell text-zinc-400">{c.email}</td>
                  <td className="p-3 font-mono">{c.order_count}</td>
                  <td className="p-3 font-mono">{inr(c.total_spend)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
